<!--suppress UnnecessaryLabelJS -->
<template>
	<v-card>
		<v-card-title>
			<v-spacer/>
			<v-spacer/>
			<v-text-field
				v-model="lookingFor"
				append-icon="mdi-magnify"
				label="חיפוש"
				single-line
				hide-details
			></v-text-field>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="lotteries"
			:loading="loading"
			class="elevation-1"
			:search="lookingFor"
		>
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

			<template #item.start_at="{item}">
				<date-span v-if="item.start_at" :date="item.start_at"></date-span>
			</template>
			<template #item.end_at="{item}">
				<date-span v-if="item.end_at" :date="item.end_at"></date-span>
			</template>
			<template #item.is_default="{item}">
				<v-switch @change="selectLottery(item,$event)" v-model="item.is_default"/>
			</template>
			<template #item.action="{item}">
				<action-td :item="item" module="lottery" @edit="onEdit">
					<v-btn @click="addPackage(item)" icon color="success">
						<v-icon>
							mdi-package
						</v-icon>
					</v-btn>
				</action-td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>

	import {types} from "src/store/modules/Lottery.module";
	import FilterAble from "src/mixins/FilterAble";
	import ActionTd from "src/components/AcationTd";
	import DateSpan from "../../components/DateSpan";

	export default {
		name: "lotteries-table",
		mixins: [new FilterAble(types)],
		props: [],
		components: {
			DateSpan,
			ActionTd
		},
		data() {
			return {
				loading: false,
				headers: [
					{
						text: "כותרת הגרלה", value: "title"
					},
					{
						text: "תיאור", value: "description"
					},
					{
						text: "תאריך התחלה", value: "start_at"
					},
					{
						text: "תאריך סיום", value: "end_at"
					},
					{
						text: "כמות כרטיסים שנמכרה", value: "cards_count"
					},
					{
						text: "מספר חבילות",value: "packages_count"
					},
					{
						text: "ההגרלה הראשית", value: "is_default"
					}, {
						text: "קישור להגרלה", value: "link"
					},
					{
						text: "פעולות", value: "action", sortable: false
					}
				],
				lookingFor: null,
				showDialog: false
			};
		},
		computed: {
			lotteries() {
				return this.$store.state.LotteryModule.lotteries;
			}
		},
		methods: {
			selectLottery(selectLottery, isSelect) {
				if (isSelect) {
					this.lotteries.forEach((lottery) => {
						if (+lottery.is_default && lottery.id !== selectLottery.id) {
							this.$store.dispatch(types.SAVE, Object.assign({}, lottery, {is_default: false}));
						}
					});
				}
				this.$store.dispatch(types.SAVE, Object.assign({}, selectLottery, {is_default: isSelect}));
			},
			onEdit(lottery) {
				this.$emit("edit", lottery);
			},
			addPackage(lottery) {
				this.$emit("package", lottery);
			}
		}
	}
	;
</script>

<style>

</style>
